import 'govuk-frontend/dist/govuk/govuk-frontend.min.css'
import { ReactNode } from 'react'

interface GovUKButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'warning' | 'danger'
  children: ReactNode
}

export function GovUKButton({
  variant = 'primary',
  className,
  children,
  ...props
}: GovUKButtonProps) {
  // 'danger' is an alias for 'warning' — GOV.UK Frontend has no --danger modifier
  const resolvedVariant = variant === 'danger' ? 'warning' : variant

  const variantClass =
    resolvedVariant === 'secondary'
      ? 'govuk-button--secondary'
      : resolvedVariant === 'warning'
        ? 'govuk-button--warning'
        : ''

  const classes = ['govuk-button', variantClass, className]
    .filter(Boolean)
    .join(' ')

  return (
    <button className={classes} data-module="govuk-button" {...props}>
      {children}
    </button>
  )
}
